import vertexShader from "../../shaders/vertex.vert";
import fragmentShader from "../../shaders/car.frag";
import MAD from "../mad-engine";

export default class Car extends MAD.Entity{
    constructor(){
        super();
        //THREE
        {
            const geometry = new THREE.BoxGeometry();
            this.color = Math.random() * 30 + 345;
            this.color %= 360;
            const uniforms = {
                u_curve: { type: "float", value: 0 },
                u_progress: { type: "float", value: 0 },
                u_color: { type: "color", value: new THREE.Color(`hsl(${this.color},100%,50%)`) }
            };
            this.material =  new THREE.ShaderMaterial( {
                vertexShader,
                fragmentShader,
                uniforms
            });

            const cube1 = new THREE.Mesh( geometry, this.material );
            cube1.scale.set(1, 1, 2);
            cube1.position.set(0,0.3,0);
            this.root.add( cube1 );
    
            const cube2 = new THREE.Mesh( geometry, this.material );
            cube2.scale.set(1, 1.1, 0.6);
            cube2.position.set(0,0.35,1.4);
            this.root.add( cube2 );
            this.root.position.z = -10 - Math.random() * 240;
        }
    
        this.lane = 0;
        this.targetX = 0;
        this.spawn();

        this.hitbox = new MAD.Hitbox({root: this.root, offset: new THREE.Vector3(0,0,0), size: new THREE.Vector3(1,1,2)});
    }

    spawn(){
        this.changeLane();
        this.root.position.x = this.getLanePosition();
        this.targetX = this.getLanePosition();
        this.speed = Math.random() * 0.1;
    }

    changeLane(){
        this.changeLaneTimer = Math.random() * 10 + 1;
        this.lane = Math.floor(Math.random() * 5 - 2);
    }

    getLanePosition(){
        return (this.lane / 5 ) * 7;
    }

    update(){
        const { clock } = MAD.App.instance;
        const { noise, player } = MAD.STORE.data;

        this.changeLaneTimer -= clock.delta;
        if(this.changeLaneTimer < 0) this.changeLane();

        if(this.hitbox.overlaps(player.hitbox)){
            this.root.position.z = -250;
            this.spawn();
            MAD.App.instance.postprocessing.glitch.enabled = true;
            setTimeout(() => MAD.App.instance.postprocessing.glitch.enabled = false, 300);
        }

        this.root.position.z += noise.getSpeed() * this.speed;
        if(this.root.position.z > 10){
            this.root.position.z = -250;
            this.spawn();
        }

        this.targetX += (this.getLanePosition() - this.targetX) * 0.01;
        this.root.position.x += (this.targetX - this.root.position.x) * 0.1;

        this.root.position.y = noise.read(this.root.position.z);
        this.root.lookAt(this.targetX, noise.read(this.root.position.z - 1), this.root.position.z - 1);

        this.material.uniforms.u_curve.value = noise.getCurve();
        this.material.uniforms.u_progress.value = noise.getProgress();
        this.material.uniforms.needsUpdate = true;
    }
}